import * as S from "./styles";
import { useToken } from "../../Components/TokenContext";
import { InitialInfo } from "../../Components/InitialInfo";
import { Footer } from "../../Components/Layout/footer";
import { Link } from "react-router-dom";
import { Header } from "../../Components/Layout/header";

import promoLogo from '../../assets/img/promoLogo.png';

function Tutorial() {
    const { tokenData } = useToken();

    const steps = [
        {
            text: "Acesse o site",
            link: "http://casabrasileiraplanejados.com.br/chancepremiada2022",
            image: "/assets/tutorial/01.png",
        },
        {
            text: 'Clique na aba "Histórico de vendas e pontuação".',
            image: "/assets/tutorial/02.jpg",
        },
        {
            text: 'Preencha o formulário e clique em "Cadastrar".',
            image: "/assets/tutorial/03.jpg",
        },
        {
            text: 'Sua solicitação será validada em relação às regras da campanha. Para acompanhar o andamento basta verificar o status dela em "Histórico de vendas e pontuação".',
            image: "/assets/tutorial/04.jpg",
        },
        {
            text: 'Confira seu saldo de pontos logo abaixo do histórico de vendas dentro da aba "Histórico de vendas e pontuação".',
            image: "/assets/tutorial/05.jpg",
        },
        {
            text: 'Na aba "Solicitar prêmios" escolha o(s) prêmio(s) clicando em "Adicionar ao carrinho".',
            image: "/assets/tutorial/06.jpg",
        },
        {
            text: "Clique no carrinho.",
            image: "/assets/tutorial/07.jpg",
        },
        {
            text: "Selecione a voltagem do prêmio solicitado. Caso o seu prêmio não mostre a opção para escolher a voltagem, ela não se aplica ao produto.",
            image: "/assets/tutorial/08.jpg",
        },
        {
            text: "Confirme seus prêmios.",
            image: "/assets/tutorial/09.jpg",
        },
    ];

    return (
        <S.Container>
            <Header isLogged={false} />

         <section className="bg-primary">
                <div className="container max-w-large">
                    <div className="flex max-md:flex-col items-center md:items-end pt-24 sm:pt-36 2xl:pt-44 pb-8 sm:pb-12">
                        <img src={promoLogo} alt="Logo da promoção" className="w-[150px] md:w-[171px] brightness-0 invert pointer-events-none" />
                        
                        <h1 className="font-secondary-xt text-4xl md:text-6xl text-tertiary font-semibold mb-6 md:ml-8 mt-4 md:mt-0">Como solicitar meus prêmios</h1>
                    </div>
                </div>
            </section>

            <div className="my-12 tutorial">
                <div className="content">
                    <p className="mt-3 mb-3">
                        *Atenção! O período para solicitar seu prêmio é de 01 de janeiro de 2027 até 15 de janeiro de 2027.
                    </p>
                    <div>
                        {steps.map((step, k) => (
                            <div key={k}>
                                <p className="mb-3 mt-3">
                                    <span className="font-secondary-xt text-primary number">{k + 1}{") "}</span>
                                    {step.link ? (
                                        <a href={step.link} target="_blank" rel="noopener noreferrer">
                                            {step.text}
                                        </a>
                                    ) : (
                                        step.text
                                    )}
                                </p>
                                <img src={step.image} alt={`Passo ${k + 1}`} />
                            </div>
                        ))}
                        <p className="font-bold mt-6">
                            É indispensável a confirmação do pedido no carrinho para garantir a solicitação dos prêmios. Caso o consultor não confirme o pedido, os pontos não são descontados e a solicitação não é recebida para análise.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />

        </S.Container>
    );
}

export default Tutorial;
